import { RCCGrid } from "react-common-components";
import styled from "styled-components";

export const ContainerAccordion = styled.div`
    .MuiButtonBase-root{
        height: 100%;
    }

    .accordion-program{
        .MuiAccordionDetails-root{
            padding:10px;
            padding-right: 0px;
        }

        .MuiCollapse-wrapper{
            border:none;
        }
    }

    .accordion-businessModel{
        width: 100%;
        box-shadow: none;

        .MuiCollapse-wrapper{
            border:none;
        }

        .MuiAccordion-root{
            box-shadow: none;
        }

        .MuiButtonBase-root{
            height: 30px;
        }

        .MuiButtonBase-root.MuiAccordionSummary-root{
            background: #9e9e9e30;

            @media(max-width: 600px){
                height: 150px;
            }

            .MuiAccordionSummary-content{
                @media(max-width: 600px){
                    height: 133px;
                }
            }
        }

        .list-component-child{
            background: transparent !important;
            background-color: transparent !important;
            border: none;
            box-shadow: none;
            height: 30px;

            div{
                overflow: visible !important;
            }
        }

        .list-component-child:hover{
            background: transparent !important;
            background-color: transparent !important;
            border: none;
            box-shadow: none !important;
        }

        .ccxyYC{
            margin: 0px;
        }
    }

    .accordion-answer{
        width: 100%;

        .MuiCollapse-wrapper{
            border:none;
        }

        .isxWuD:hover.li.list-component-child:hover{
            box-shadow: none;
        }

        .MuiButtonBase-root.MuiAccordionSummary-root{
            background: #9e9e9e14;
        }

        .MuiAccordionDetails-root{
            .MuiCollapse-wrapper{
                padding: 0px 10px 0px 10px;
            }
        }
    }

    .container-actions{
        width: 100%;
        .list-component-child{
            height: 100%;
            border-bottom: 1px solid var(--border-color);
            box-shadow: 0 2px 1px -1px var(--border-color);
        }

        .list-component-child:hover{
            height: 100%;
            border-bottom: 1px solid var(--border-color);
            box-shadow: 0 2px 1px -1px var(--border-color);
        }
    }

    ul.ul-businessModel-head{
        width: 100%;
    }

    li.businessModel-head{
        border-top: 1px solid var(--border-color);
        border-bottom: 1px solid var(--border-color);
        background: var(--li-header-color);
        color: var(--default-color-font);
        padding: 4px;
        margin: 5px 0;
        font-size: 0.9rem;
        font-weight: bold;

        @media(max-width: 600px){
            display: none;
        }        
    }

    .head-title{
            display: block;

            @media(max-width: 971px){
                background-color: blue;
                display: none;
            }
        }
`;



export const StrategyQuadrants = styled(RCCGrid)`
    width: 100%;
    padding: 0.5rem 1rem;
`;
